import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Check } from '@phosphor-icons/react';

import { OrbitDrawer } from 'enrollment/components/Shared/OrbitDrawer';
import { useOliveAdvisorEnabled } from 'enrollment/features/OliveAdvisor/components/OliveAdvisorEnabled';

interface OliveRecommendsProps {
  reasons: string;
  drawerOpen: boolean;
  planName: string;
  selected?: boolean;
}

export const OliveRecommends: React.FC<OliveRecommendsProps> = ({
  reasons,
  planName,
  selected,
}) => {
  const { t } = useTranslation('oliveAdvisor');
  const isMobile = window.innerWidth < 744;

  const [drawerOpen, setDrawerOpen] = useState(false);

  function handleDrawerClose() {
    setDrawerOpen(false);
    document.getElementById('reasons-link')?.focus();
  }

  const oliveAdvisorEnabled = useOliveAdvisorEnabled();

  if (oliveAdvisorEnabled) {
    return (
      <>
        <div id="olive-recommends">
          <div className="blue-info-box">
            <div className="d-flex">
              <div className="olive-container mr-2">
                <div
                  className="olive-icon"
                  aria-hidden="true"
                  role="presentation"
                ></div>
              </div>
              <div>
                <p className="headline-3">
                  {t('recommend.title_a')} {planName} {t('recommend.title_b')}
                </p>
                <p className="mb-0 olive-reasons">
                  {isMobile ? (
                    <>
                      <a
                        id="reasons-link"
                        href="#"
                        onClick={() => {
                          setDrawerOpen(true);
                        }}
                      >
                        {t('recommend.clickHere')}
                      </a>{' '}
                      {t('recommend.findOut')}
                      <OrbitDrawer
                        drawerId="reasonsDrawer"
                        heading={t('recommend.findOutWhy')}
                        isOpen={drawerOpen}
                        handleClose={handleDrawerClose}
                      >
                        {reasons}
                      </OrbitDrawer>
                    </>
                  ) : (
                    <>{reasons}</>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="recommended-indicator">
          {selected && (
            <>
              <Check size={17} color="white" />
              {t('recommend.chosen')} &amp; &nbsp;
            </>
          )}
          {t('recommend.suggestion')}
        </div>
      </>
    );
  }
};
